import { addTeam as addTeamApi } from "../api/teamApi";
import { addTeamMember } from "../api/teamMemberApi";

type AddTeamInput = {
  name: string;
  organizationId: string;
  leadUid?: string;
  notifications?: unknown;
  causeTypeIds?: unknown;
};

type Team = {
  id: string;
  name: string;
  organizationId: string;
};

// experience-backend only supports creating teams and team members
// (POST /team, POST /teammember) — there's no update/delete endpoint for
// teams or team membership yet, so those stay honest stubs.
export const TeamService = {
  async addTeam({ name, organizationId, leadUid }: AddTeamInput): Promise<Team> {
    const id = await addTeamApi({ name, organizationId });
    if (leadUid) {
      try {
        await addTeamMember({ userId: leadUid, teamId: String(id) });
      } catch (error) {
        console.warn("TeamService.addTeam: failed to add team lead as a member:", error);
      }
    }
    return { id: String(id), name, organizationId };
  },

  async updateTeam(
    _teamId: string,
    _name: string,
    _notifications?: unknown,
    _causeTypeIds?: unknown,
    _reportDay?: unknown
  ): Promise<void> {
    console.warn("TeamService.updateTeam: not supported by experience-backend yet.");
  },

  async applyTeamMemberRemovalsSinceBaseline(
    _teamId: string,
    _baseline: unknown[],
    _current: unknown[]
  ): Promise<void> {
    console.warn(
      "TeamService.applyTeamMemberRemovalsSinceBaseline: not supported by experience-backend yet."
    );
  },

  async removeTeamMemberFromTeam(_teamId: string, _userId: string): Promise<void> {
    console.warn(
      "TeamService.removeTeamMemberFromTeam: not supported by experience-backend yet."
    );
  },
};
